"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgenciesAutocompleteInput = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const components_common_highlight_1 = require("@hotelplan/components.common.highlight");
const core_basis_bs_icon_1 = require("@hotelplan/core.basis.bs-icon");
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const fdr_regular_fusion_fdr_autocomplete_option_1 = require("@hotelplan/fdr.regular.fusion.fdr-autocomplete-option");
const fdr_agency_map_search_styles_1 = require("./fdr-agency-map-search.styles");
const fdr_agency_map_search_utils_1 = require("./fdr-agency-map-search.utils");
const renderTagLabel = (item, label) => (react_1.default.createElement(fdr_regular_fusion_fdr_autocomplete_option_1.FdrAutocompleteOption, { icon: react_1.default.createElement(core_basis_bs_icon_1.BsIcon, { style: { color: 'black' }, name: (0, fdr_agency_map_search_utils_1.getIconNameForSuggestion)(item) }), label: label }));
const renderItemLabel = (item, query) => renderTagLabel(item, react_1.default.createElement(components_common_highlight_1.HighlightText, { text: item.name || '', substring: query }));
const MAX_ZIP_VALUE_LENGTH = 4;
const AgenciesAutocompleteInput = props => {
    const { selected, onSelect, onSearchAroundMe, className, children } = props;
    const [t] = (0, next_i18next_1.useTranslation)('agency');
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    const controlRef = (0, react_1.useRef)(null);
    function onAroundMeClick() {
        var _a;
        onSearchAroundMe((_a = controlRef.current) === null || _a === void 0 ? void 0 : _a.close);
    }
    function valueInterceptor(next) {
        if (/^\d+[^\d]$/.exec(next)) {
            return next.replace(/[^0-9]+$/, '').slice(0, MAX_ZIP_VALUE_LENGTH);
        }
        if (/^\d+$/.exec(next)) {
            return next.slice(0, MAX_ZIP_VALUE_LENGTH);
        }
        return next;
    }
    return (react_1.default.createElement(fdr_agency_map_search_styles_1.AgenciesAutocompleteComboboxInput, { controlRef: controlRef, name: "agenciesAutocomplete", placeholder: t('agency:search.placeholder'), icon: { name: 'location' }, value: selected ? [selected] : [], onChange: (nextItems) => {
            onSelect(nextItems[0]);
        }, renderSuggestion: renderItemLabel, renderTagLabel: (item) => renderTagLabel(item, item.name), getTagName: (item) => item.name, displayValue: (selected === null || selected === void 0 ? void 0 : selected.name) || '', onOptionSelect: (_, __, popupControl) => {
            // Apply/Close autocomplete modal
            popupControl.apply();
        }, maxItems: 1, valueInterceptor: valueInterceptor, className: className },
        onSearchAroundMe && mobile ? (react_1.default.createElement(fdr_agency_map_search_styles_1.AroundMeButton, { variant: "linkBtn", testId: "around-me-btn", icon: { name: 'aroundme', size: 'lg' }, onClick: onAroundMeClick }, t('agency:search.aroundMe'))) : null,
        children));
};
exports.AgenciesAutocompleteInput = AgenciesAutocompleteInput;
//# sourceMappingURL=fdr-agency-autocomplete-input.js.map